import { render, staticRenderFns } from "./cardTemplateVip23.vue?vue&type=template&id=0bae0c78&scoped=true&"
import script from "./cardTemplateVip23.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip23.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip23.vue?vue&type=style&index=0&id=0bae0c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae0c78",
  null
  
)

export default component.exports